module.exports = __webpack_public_path__ + "img/white-no-entry.97e96227.svg";